import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';
import { Grid } from '@alfa-bank/site-grid-universal';

import { NewsItemDesktop as NewsItem } from '../../news-item/desktop';
import type { IInvestMediaportalHeadlinesProps } from '../models';

import styles from './styles.css';

export const InvestMediaportalHeadlinesNewsBlockDesktop: FC<IInvestMediaportalHeadlinesProps> = ({
    analytics,
    articles,
    baseUrlToArticle,
}) => {
    return (
        <Grid
            className={cn(styles.external, styles.grid)}
            collapse
            dataTestId="headlines-block"
            justify="start"
        >
            {articles.map(item => {
                return (
                    <NewsItem
                        key={item.path}
                        analytics={analytics}
                        baseUrlToArticle={baseUrlToArticle}
                        {...item}
                    />
                );
            })}
        </Grid>
    );
};
